import { styled, Grid } from '@mui/material';

export const OuterWrapper = styled(Grid)((props: { isMobileView: boolean }) =>`
  display: flex;
  flex-direction: ${props.isMobileView ? 'column-reverse' : 'row'};
  align-items: ${props.isMobileView ? 'flex-end' : 'center'};
`);

export const TextfieldWrapper = styled(Grid)((props: { isMobileView: boolean }) =>`
  display: flex;
  margin-right: ${props.isMobileView ? '0px' : '20px'};
`);

export const TextInputWrapper = styled(Grid)`
  flex: 1;
`;

export const TooltipWrapper = styled(Grid)`
  align-content: flex-end;
  margin-left: 3px;
`;